import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CgmModulePageLayout from './layout/CgmModulePageLayout';
import './CgmFilterToolbar.css';
import './CgmModulePage.css';
import EtatCgmModal from './EtatCgmModal';
import { getActiveCaisseYear, buildCaisseYearOptions } from '../utils/caisseActiveYear';

const years = buildCaisseYearOptions();

function buildEtatPageQuery({ tab, jourMode, selectedDate, dateDebut, dateFin, selectedMonth, selectedYear }) {
    const p = new URLSearchParams();
    if (tab === 'jour' && jourMode === 'date' && selectedDate) {
        p.set('filterType', 'jour');
        p.set('date', selectedDate);
    } else if (tab === 'jour' && jourMode === 'periode' && dateDebut && dateFin) {
        p.set('filterType', 'periode');
        p.set('dateDebut', dateDebut);
        p.set('dateFin', dateFin);
    } else if (tab === 'mois') {
        p.set('filterType', 'mois');
        p.set('mois', String(selectedMonth));
        p.set('annee', String(selectedYear));
    } else if (tab === 'annee') {
        p.set('filterType', 'annee');
        p.set('annee', String(selectedYear));
    }
    return p.toString();
}

function FondClientCgmPanel({
    panelId,
    panelLabel,
    fondClientView = 'etat',
    cardTitle = 'Filtrer l\'état',
    buttonLabel = "Afficher l'état",
}) {
    const navigate = useNavigate();
    const [selectedYear, setSelectedYear] = useState(() => getActiveCaisseYear());
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [selectedDate, setSelectedDate] = useState(() => new Date().toISOString().split('T')[0]);
    const [dateDebut, setDateDebut] = useState('');
    const [dateFin, setDateFin] = useState('');
    const [tab, setTab] = useState('annee');
    const [jourMode, setJourMode] = useState('date');
    const [showModal, setShowModal] = useState(false);
    const [openEtatError, setOpenEtatError] = useState('');

    const handleShowEtat = () => {
        window.currentEtatClientId = null;
        window.currentEtatType = 'fond-client-cgm';
        setShowModal(true);
    };

    const handleOpenEtatPdfPage = () => {
        const qs = buildEtatPageQuery({
            tab,
            jourMode,
            selectedDate,
            dateDebut,
            dateFin,
            selectedMonth,
            selectedYear,
        });
        if (!qs) {
            setOpenEtatError('Choisissez une période valide (date, période complète, mois ou année).');
            return;
        }
        setOpenEtatError('');
        navigate(`/fond-client-cgm/etat?${qs}`);
    };

    const jDateId = `fond-jdate-${panelId}`;
    const jPeriodeId = `fond-jperiode-${panelId}`;

    return (
        <>
            <div className="cgm-filter-panel cgm-period-panel h-100">
                <div className="cgm-filter-panel__title">{cardTitle}</div>
                <div className="cgm-period-body">
                    <span className="cgm-period-badge">{panelLabel}</span>

                    <div className="cgm-period-tabs">
                        <button type="button" className={`cgm-period-tab ${tab === 'jour' ? 'active' : ''}`} onClick={() => setTab('jour')}>Jour</button>
                        <button type="button" className={`cgm-period-tab ${tab === 'mois' ? 'active' : ''}`} onClick={() => setTab('mois')}>Mois</button>
                        <button type="button" className={`cgm-period-tab ${tab === 'annee' ? 'active' : ''}`} onClick={() => setTab('annee')}>Année</button>
                    </div>

                    {tab === 'jour' && (
                        <div className="cgm-period-jour-panel">
                            <div className="cgm-period-mode-group" role="group" aria-label={`Mode jour ${panelId}`}>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" id={jDateId} name={`fond-jmode-${panelId}`} checked={jourMode === 'date'} onChange={() => setJourMode('date')} />
                                    <label className="form-check-label" htmlFor={jDateId}>Par date</label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" id={jPeriodeId} name={`fond-jmode-${panelId}`} checked={jourMode === 'periode'} onChange={() => setJourMode('periode')} />
                                    <label className="form-check-label" htmlFor={jPeriodeId}>Par période</label>
                                </div>
                            </div>
                            <div className="cgm-period-filter-row">
                                {jourMode === 'date' ? (
                                    <>
                                        <label className="mb-0">Date</label>
                                        <input type="date" className="hono-input-date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} />
                                    </>
                                ) : (
                                    <>
                                        <label className="mb-0">De</label>
                                        <input type="date" className="hono-input-date" value={dateDebut} onChange={(e) => setDateDebut(e.target.value)} />
                                        <label className="mb-0">à</label>
                                        <input type="date" className="hono-input-date" value={dateFin} onChange={(e) => setDateFin(e.target.value)} />
                                    </>
                                )}
                            </div>
                        </div>
                    )}

                    {tab === 'mois' && (
                        <div className="cgm-period-filter-row">
                            <label className="mb-0">Mois</label>
                            <select className="hono-select-month" value={selectedMonth} onChange={(e) => setSelectedMonth(parseInt(e.target.value, 10))}>
                                {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
                                    <option key={m} value={m}>{String(m).padStart(2, '0')}</option>
                                ))}
                            </select>
                            <label className="mb-0">Année</label>
                            <select className="hono-select-year" value={selectedYear} onChange={(e) => setSelectedYear(parseInt(e.target.value, 10))}>
                                {years.map((y) => (
                                    <option key={y} value={y}>{y}</option>
                                ))}
                            </select>
                        </div>
                    )}

                    {tab === 'annee' && (
                        <div className="cgm-period-filter-row">
                            <label className="mb-0">Année</label>
                            <select className="hono-select-year" value={selectedYear} onChange={(e) => setSelectedYear(parseInt(e.target.value, 10))}>
                                {years.map((y) => (
                                    <option key={y} value={y}>{y}</option>
                                ))}
                            </select>
                        </div>
                    )}

                    <div className="cgm-period-actions">
                        <button
                            type="button"
                            className="cgm-toolbar-btn cgm-toolbar-btn--primary"
                            onClick={fondClientView === 'mouvements' ? handleOpenEtatPdfPage : handleShowEtat}
                        >
                            {buttonLabel}
                        </button>
                    </div>

                    {fondClientView === 'mouvements' && openEtatError && (
                        <p className="cgm-period-error mb-0" role="alert">{openEtatError}</p>
                    )}
                </div>
            </div>

            {showModal && fondClientView === 'etat' && (
                <EtatCgmModal
                    key={`etat-fond-${panelId}`}
                    show={showModal}
                    onClose={() => setShowModal(false)}
                    type="fond-client-cgm"
                    filterType={tab === 'jour' ? (jourMode === 'date' ? 'jour' : 'periode') : tab}
                    date={tab === 'jour' && jourMode === 'date' ? selectedDate : null}
                    dateDebut={tab === 'jour' && jourMode === 'periode' ? dateDebut : null}
                    dateFin={tab === 'jour' && jourMode === 'periode' ? dateFin : null}
                    mois={tab === 'mois' ? selectedMonth : null}
                    annee={tab === 'mois' || tab === 'annee' ? selectedYear : null}
                    fondClientView="etat"
                />
            )}
        </>
    );
}

export default function FondClientChezCgmPage() {
    return (
        <CgmModulePageLayout
            crumb="Comptabilité CGM · Fonds clients"
            title="État fond client"
            subtitle="Comparez l'état synthèse et le détail mouvements sur deux périodes côte à côte."
            backTo="/"
            wide
        >
            <div className="cgm-module-split-row">
                <FondClientCgmPanel
                    panelId="left"
                    panelLabel="État fond client"
                    fondClientView="etat"
                    cardTitle="État du fond client"
                    buttonLabel="Afficher l'état"
                />
                <FondClientCgmPanel
                    panelId="right"
                    panelLabel="Fond client"
                    fondClientView="mouvements"
                    cardTitle="Fond client"
                    buttonLabel="Ouvrir l'état / PDF"
                />
            </div>
        </CgmModulePageLayout>
    );
}
